import React from "react";
import SwoodleLogo from "../../../Assets/Icons/SwoodleUpdatedLogo.svg";
import TextInput from "../SignUp/TextInput";
import { useLocation, useNavigate, NavLink } from "react-router-dom";
import { useFormik } from "formik";
import { forgetPasswordSchema } from "../../../utils/validationSchemas";
import { useDispatch, useSelector } from "react-redux";
import { setForgetPasswordData } from "../../../redux/slices/authSlice";
import { forgetPassword } from "../../../services/authService";
import PrimaryButton from "../PrimaryButton";
import SwoodleFooter from "../SwoodleFooter";
import LoginHeader from "../LoginHeader";

const responsiveShellStyle = {
  width: "100%",
  maxWidth: "min(1920px, calc(100vw - 2vw))",
  margin: "0 auto",
};

const ForgetPasswordForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const signupResume = location.state?.signupResume;
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  const navigation = () => {
    navigate("/otp-verification", {
      state: signupResume ? { signupResume } : null,
    });
  };

  const formik = useFormik({
    initialValues: {
      email: signupResume?.email || "",
    },
    enableReinitialize: true,
    validationSchema: forgetPasswordSchema,
    onSubmit: async (values, { setFieldError }) => {
      setLoading(true);
      try {
        const response = await dispatch(
          forgetPassword({ email: values.email })
        ).unwrap();

        if (response?.success) {
          dispatch(setForgetPasswordData({ email: values.email }));
          navigation();
        }
      } catch (err) {
        console.error("Forget password error:", err);
        // The user specifically wants "Incorrect Email" shown below the field
        setFieldError("email", "Incorrect Email");
      } finally {
        setLoading(false);
      }
    },
  });

  const { email } = formik.values;

  const { handleChange, handleBlur, handleSubmit, errors, touched } = formik;

  return (
    <form onSubmit={handleSubmit}>
      <div className="min-h-screen bg-white flex flex-col">
        <div className="w-full px-6 py-4">
          <div style={responsiveShellStyle}>
            <LoginHeader />
          </div>
        </div>

        <div className="flex-1 w-full flex flex-col items-center">
          <div className="w-full max-w-[640px] px-12 mt-10">
            <h2 className="text-center text-[26px] md:text-[30px] font-[600] font-poppins text-[#303030]">Recover Account</h2>
            <p className="text-center text-[#8C8C8C] mt-1 text-[14px] md:text-[15px]">
              Provide your email address and we'll send you a link to reset your password.
            </p>

            <div className="mt-8 space-y-4 flex flex-col items-center">
              <div className="w-[360px] sm:w-[420px] md:w-[460px]">
                <TextInput
                  name={"email"}
                  value={email}
                  placeholder={"Enter your email"}
                  inputClass={"h-full bg-[#F2F4F5] border border-[#EFF2F5] rounded-[12px] px-4 text-[16px] font-poppins font-[500] placeholder:text-[#8C8C8C]"}
                  innerDivClass={"h-[56px] w-full items-center"}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  error={errors.email}
                  touched={touched.email}
                  readOnly={Boolean(signupResume)}
                />
              </div>

              <div className="pt-1" />
            </div>

            <div className="mt-6 flex justify-center">
              <PrimaryButton
                type="submit"
                className="w-[360px] sm:w-[420px] md:w-[460px] h-[60px] rounded-[8px] font-[600]"
                label="Recover"
                loading={loading}
              />
            </div>

            <div className="mt-6 text-center text-[14px] md:text-[15px] text-[#303030] font-poppins">
              Don't have an account?
              <span className="ml-2 font-[500] text-[#303030]">Register as</span>
              <NavLink to="/merchant/getting-started" className="ml-2 text-[#00ADEF] font-[600]">Merchant</NavLink>
              <span className="mx-1 text-[#00ADEF]">/</span>
              <NavLink to="/fundraiser/getting-started" className="text-[#00ADEF] font-[600]">Fundraiser</NavLink>
            </div>
          </div>
        </div>

        <div className="mt-16">
          <SwoodleFooter containerStyle={responsiveShellStyle} enableEntranceAnimation={true} />
        </div>
      </div>
    </form>
  );
};

export default ForgetPasswordForm;
